module.exports = __webpack_public_path__ + "040a91b0e60964bf31904363f95a23b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/de.svg
// module id = 55
// module chunks = 0